var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2BpaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.50078C1 4.04948 1 2.82383 1.76152 2.0623C2.52304 1.30078 3.7487 1.30078 6.2 1.30078H8.8C11.2513 1.30078 12.477 1.30078 13.2385 2.0623C14 2.82383 14 4.04948 14 6.50078C14 8.95208 14 10.1777 13.2385 10.9393C12.477 11.7008 11.2513 11.7008 8.8 11.7008H6.2C3.7487 11.7008 2.52304 11.7008 1.76152 10.9393C1 10.1777 1 8.95208 1 6.50078Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19998 9.10156H3.59998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80001 9.10156H7.82501",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.20117L14 5.20117",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BpaymentMethod);
export default __webpack_public_path__ + "static/media/b2b.paymentMethod.710826a2ca422bf1027752acd69b0e8d.svg";
export { ForwardRef as ReactComponent };